import { BarChart3, Clock3, Group, ListChecks, UserRound } from "lucide-react";

export function HomePage() {
  const features = [
    [UserRound, "Gestione studenti con storico"],
    [ListChecks, "Quiz adattivi per materia e livello"],
    [BarChart3, "Monitoraggio intuitivo dei progressi"],
    [Group, "Visione aggregata per genitori e docenti"],
    [Clock3, "Domande a tempo per migliorare la concentrazione"]
  ] as const;

  return <section className="blazor-home">
    <h1>Benvenuto in BrainPower</h1>
    <p className="blazor-home-subtitle">Il sistema intelligente per allenare, monitorare e far crescere le capacità dello studente.</p>
    <article className="blazor-home-card">
      <h2>Cosa può fare BrainPower?</h2>
      <ul>{features.map(([FeatureIcon, label]) => <li key={label}><FeatureIcon /><span>{label}</span></li>)}</ul>
    </article>
  </section>;
}
